import {Component, Input} from '@angular/core';
import {NgClass} from "@angular/common";
import {SafeHtml} from "@angular/platform-browser";

@Component({
  selector: 'ui-atom-text',
  standalone: true,
  imports: [
    NgClass
  ],
  templateUrl: './ui-atom-text.component.html',
  styleUrl: './ui-atom-text.component.scss'
})
export class UiAtomTextComponent {

  @Input() text: string | SafeHtml = '';
  @Input() type: 'main-title' | 'title' | 'emphasis' | 'label' | 'caption' | 'regular' | 'medium' | 'small' | 'supersmall' = 'regular';

}
